<template>
  
  <div :id="$vnode.key" class="draggable" role="button" :class="{'selected': selected}" @click="selected = !selected">
      <img class="img-fluid"
        :data-flickity-lazyload="imgSrc"
        :alt="alt">
  </div>
  
</template>

<script>
import Draggabilly from 'draggabilly'

export default {
  name: 'DraggableRight',
  props: [
    'label',
    'title',
    'imgSrc',
    'alt'
  ],
  data: function(){
    return {
        inbounds: false,
        dropzone: null,
        duplicateEl: null,
        selected: false
    }
  },
  methods: {
    initDraggables(el){
        var draggie = new Draggabilly( el, {
            // containment: '#flickity_container'
        });

        draggie.on('dragStart', function(event, pointer){
            var newId = event.target.id + '_dupe';
            var dupeEl = event.target.parentNode.cloneNode(true)
            var container = pointer.target.parentNode.parentNode;

            dupeEl.id = newId;
            dupeEl.classList.remove('is-dragging')
            this.$data.duplicateEl = container.appendChild(dupeEl);
            this.initDraggables(this.$data.duplicateEl);
        }.bind(this))

        draggie.on('dragMove', function(event, pointer){
            pointer.target.getBoundingClientRect()
            var draggieRect = pointer.target.getBoundingClientRect();
            var dzones = document.getElementsByClassName('dropzone-square');

            for(var i=0; i < dzones.length; i++){
                var $dz_el = dzones[i];
                var dzone = $dz_el.getBoundingClientRect()
                var dzone_center_x = dzone.left + (dzone.width / 2)
                var dzone_center_y = dzone.top + (dzone.height / 2)
                var drag_center_x = draggieRect.left + (draggieRect.width / 2)
                var drag_center_y = draggieRect.top + (draggieRect.height / 2)

                var in_range_x = Math.abs(dzone_center_x - drag_center_x) < 100
                var in_range_y = Math.abs(dzone_center_y - drag_center_y) < 100
            
                if(in_range_x & in_range_y){
                    $dz_el.classList.add("active");
                    this.$data.inbounds = true
                    this.$data.dropzone = $dz_el
                    break;
                } else {
                    $dz_el.classList.remove("active");
                    this.$data.inbounds = false
                    this.$data.dropzone = null
                }
            }
        }.bind(this))  

        draggie.on('dragEnd', function(event, pointer){
            if(this.$data.dropzone){
                pointer.target.classList.remove("draggable")
                pointer.target.classList.add("dropped")
                pointer.target.parentNode.outerHTML = null;
                this.$data.dropzone.classList.remove("active");
                this.$emit('dropped', this.$data.dropzone.id, this.$props.imgSrc, this.$props.label, this.$props.title, this.$props.alt)
            } else {
                //pointer.target.classList.remove("dropped")
                draggie.destroy();
            }
        }.bind(this))

        draggie.on('staticClick', function(){
            this.$emit('clicked', this.$props.imgSrc, this.$props.label, this.$props.title, this.$props.alt)
        }.bind(this))
    }
  },
  mounted(){
    this.initDraggables(document.querySelector('#' + this.$vnode.key));
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .draggable{
        color: black;
        display: inline-block;
        transition: opacity 0.3s;
        cursor: move;
        z-index: 0;
        width: 100%;
        
        position: absolute;
        pointer-events: auto;
    }
    .draggable img {
        width: 100%;
        height: 100%;
    }
    .draggable.is-pointer-down,
    .draggable.is-dragging{
        opacity: 0.7;
        z-index: 1;
        position: absolute;
    }
    .draggable.dropped {
        background-color: rgba(255,255,255,0);
    }

    .draggable.selected {
        border: 5px solid white;
    }
    /* @media (min-width: 576px){
        .draggable.selected {
            border: inherit;
        }
    } */
</style>
